// extracted by mini-css-extract-plugin
export var deliveryRow = "_om-a";
export var fixedHeight = "_om-4";
export var freightLogo = "_om-9";
export var fullWidth = "_om-3";
export var priceColumn = "_om-5";
export var radioSelected = "_om-7";
export var radioUnselected = "_om-6";
export var selectedOption = "_om-2";
export var selectedOptionContainer = "_om-1";
export var selection = "_om-0";
export var tallSkeletonText = "_om-8";